import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-microsoftword',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Microsoft Word icon</title><path d="M23.004 1.5q.41 0 .703.293t.293.703v19.008q0 .41-.293.703t-.703.293H6.996q-.41 0-.703-.293T6 21.504V18H.996q-.41 0-.703-.293T0 17.004V6.996q0-.41.293-.703T.996 6H6V2.496q0-.41.293-.703t.703-.293zM6.035 11.203l1.442 4.735h1.64l1.57-7.876H9.036l-.937 4.653-1.325-4.5H5.38l-1.406 4.523-.938-4.675H1.312l1.57 7.874h1.641zM22.5 21v-3h-15v3zm0-4.5v-3.75H12v3.75zm0-5.25V7.5H12v3.75zm0-5.25V3h-15v3Z"/></svg>`,
    styles: []
})
export class SimpleIconsMicrosoftwordComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#2B579A';
    @Input() className: string = 'simple-icons-microsoftword'
    constructor() {}
    ngOnInit(): void {}
}
